module.exports = ".upload-ui {\n  padding: 15px 0px; }\n  .upload-ui .btn {\n    display: inline-block !important; }\n  .upload-ui .table th, .upload-ui .table td {\n    border-top-width: 0px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/upload/upload.component.scss
// module id = ./src/app/modules/upload/upload.component.scss
// module chunks = main